module.exports = __webpack_public_path__ + "media/loose.61373d04.wav";